import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs';
import { CategoryEndpoints } from '../../config/category/category-end-point';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }
  

  getCategory<T>(reqModel:any): Observable<any>{        
    return this.genericApiService.post(CategoryEndpoints.GetCategory, reqModel);
   } 

  addUpdateCategory<T>(model: any): Observable<HttpResponse<T>> {
   return this.genericApiService.post(CategoryEndpoints.SaveCategory, model);
  }
 
  deleteCatgory<T>(id: number,SiteId:number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${CategoryEndpoints.DeleteCategory}/${id}/${SiteId}`);
   }
  // deleteCatgory<T>(CategoryId: number): Observable<HttpResponse<T>> {
  //   return this.genericApiService.delete(`${CategoryEndpoints.DeleteCategory}/${CategoryId}`);
  //  }

   GetCategoryDataReArrange<T>(reqModel:any): Observable<unknown>{ 
    return this.genericApiService.post(CategoryEndpoints.GetCategoryDataReArrange, reqModel);
  }

  CheckActiveCategory<T>(id: number,categoryId:number): Observable<HttpResponse<T>>{ 
    return this.genericApiService.get(`${CategoryEndpoints.CheckActiveCategory}/${id}/${categoryId}`);
  }

}
